import { Link } from 'react-router-dom';
import Arrow from '../../../components/ui/Arrow';
import { localizedPath, useLocale, useMessages } from '../../../i18n/locale';
import FadeInOnScroll from '../../../components/effects/FadeInOnScroll';
import BlurText from '../../../components/effects/BlurText';
import PartnerLogoStrip from './PartnerLogoStrip';

export default function ContactSection() {
  const locale = useLocale();
  const copy = useMessages().home.contact;
  return (
    <section id="cooperation" className="contact-section">
      <div className="container contact-inner">
        <PartnerLogoStrip copy={copy.brands} />
        <FadeInOnScroll className="contact-heading">
          <h2>
            <BlurText text={copy.title[0]} />
            <br />
            <BlurText text={copy.title[1]} delay={140} />
          </h2>
          <p>{copy.description}</p>
        </FadeInOnScroll>
        <FadeInOnScroll className="contact-paths" delay={100}>
          {copy.paths.map((path, index) => (
            <Link
              key={path.label}
              className={`contact-path contact-path--${index === 0 ? 'business' : 'community'}`}
              to={localizedPath(locale, index === 0 ? '/company/contact' : '/community')}
            >
              <div className="contact-path__top">
                <span className="contact-path__number">0{index + 1}</span>
                <span className="contact-path__label">{path.label}</span>
              </div>
              <div className="contact-path__content">
                <strong>{path.title}</strong>
                <p>{path.description}</p>
                <ul className="contact-path__topics">
                  {path.topics.map((topic) => (
                    <li key={topic}>{topic}</li>
                  ))}
                </ul>
              </div>
              <span className="contact-path__action">
                {path.action}
                <Arrow up />
              </span>
            </Link>
          ))}
        </FadeInOnScroll>
        <div className="contact-bottom">
          <Link
            to={localizedPath(locale)}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            {copy.back} ↑
          </Link>
        </div>
      </div>
    </section>
  );
}
